// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".model-search-select-page[data-v-aa6a8e3e]{position:sticky;bottom:0;padding:5px 0;background:#fff}.model-search-select-input[data-v-aa6a8e3e] .el-input__validateIcon{display:none}", ""]);
// Exports
module.exports = exports;
